import {
  WalletProviderPriority,
  getDefaultClient,
  getWalletProviderRegistry,
  hasExtension,
  registerExtension,
} from '@dynamic-labs-sdk/client/core';

import { createZerodevWalletProvider } from '../utils/createZerodevWalletProvider';

export const ZERODEV_EXTENSION_KEY = 'zerodev';

/**
 * Adds the ZeroDev extension to the Dynamic client.
 *
 * This extension enables Account Abstraction integration with ZeroDev
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 */
export const addZerodevExtension = (client = getDefaultClient()) => {
  if (hasExtension({ extensionKey: ZERODEV_EXTENSION_KEY }, client)) {
    return;
  }

  registerExtension({ extensionKey: ZERODEV_EXTENSION_KEY }, client);

  const walletProviderRegistry = getWalletProviderRegistry(client);

  const walletProvider = createZerodevWalletProvider(client);

  walletProviderRegistry.register({
    priority: WalletProviderPriority.WALLET_SDK,
    walletProvider,
  });
};
